module.exports = __webpack_public_path__ + "img/4-3.2b2ad4e9.svg";